export enum ErrorMessages {
  USER_EXIST= "Ein Nutzer mit dieser E-Mail Adresse existiert bereits"
}
